<template>
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="海尔账号及权益" name="1">
        一、权益更换/取消 <br/><br/>
        您好，购机产生的“实物/积分权益”具备活动绑定特性，商城不支持更换及取消操作，敬请谅解。<br/><br/>
        二、权益领取<br/><br/>
        您好，您可以使用绑定权益手机登录海尔智家APP-个人中心-我的奖品，查看账号激活待领取权益，按页面操作指引完成实物/积分权益的领取及使用。
      </van-collapse-item>
      <van-collapse-item title="常见兑换问题" name="2">
        <p>
          一、兑换方式<br/><br/>
          海尔积分商城商品兑换支付方式为“积分”兑换，暂不支持“现金或积分+现金支付”兑换方式， 请悉知。<br/><br/>
          二、兑换流程<br/><br/>
          积分商城支持电脑端，手机海尔智家APP或关注微信公众号“海尔智家“进行积分兑换，积分商城目前在架礼品包含实体及虚拟礼品，兑换流程如下：
          【实体类礼品兑换】：商品查询筛选——确认商品信息——确认收货人信息——下单支付
          【虚拟类礼品兑换】：商品查询筛选——确认商品信息——确认收货人信息——下单支付——虚拟券码短信查收（注：部分虚拟商品短信仅为兑换成功凭证，无需激活使用，具体请以商品详情页操作指导为准）<br/><br/>
          三、商品质量说明<br/><br/>
          商城保证所兑换的商品为正规渠道进货，商品的来源经专业采购严格把关，均为正品。如商品有质量问题或者发错，商品供应商会为您采取换货的补救措施，其中所产生物流费用由商品供应商全部承担。<br/><br/>
          四、商品兑换说明<br/><br/>
          在会员累计和使用积分的过程中，如出现兑换违规行为，包括但不限于：作弊累计、恶意套现、虚假交易等，积分商城将保留不另行通知而取消该会员参与积分兑现的权利，并有权撤销因违规行为所累计的积分，以及采取其他相应法律措施的权利。
        </p>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { sysNotice } from "@/api/api";
export default {
  data() {
    return {
      list: [],
      activeNames: [],
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 50px;
}
/deep/.blue {
  color: #2283e2 !important;
}
.contai {
  background: #fff;
  // border: 1px solid #2283e2;
  padding: 20px;
}

.header {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #2283e2;
}

.paging {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.title {
  font-size: 25px;
  cursor: pointer;
}

.title:hover {
  color: #2283e2;
}
</style>
